function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.459 1.643c8.404 0 15.216 6.792 15.216 15.17 0 5.099-3.578 10.717-6.147 14.127-2.428 3.222-2.374 8.212-2.374 8.212-.067.726-.51 1.328-1.142 1.328H20.905c-.632 0-1.074-.602-1.14-1.328 0 0 .053-4.99-2.375-8.212-2.57-3.411-6.147-9.028-6.147-14.126 0-8.379 6.812-15.171 15.216-15.171z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.199 40.48h8.521c1.349 0 2.435.812 2.435 1.82 0 1.01-1.086 1.821-2.435 1.821h-8.521c-1.349 0-2.435-.812-2.435-1.82 0-1.01 1.086-1.821 2.435-1.821z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.199 44.121h8.521c1.349 0 2.435.812 2.435 1.82s-1.086 1.821-2.435 1.821h-8.521c-1.349 0-2.435-.812-2.435-1.82S20.85 44.12 22.2 44.12zM22.199 47.762h8.521c1.349 0 2.435.812 2.435 1.82s-1.086 1.821-2.435 1.821h-8.521c-1.349 0-2.435-.812-2.435-1.82s1.086-1.821 2.435-1.821z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.818 47.724c-.004.024.004.052 0 .076.124-.015.25-.038.38-.038-.13 0-.256-.023-.38-.038zm9.282 0c-.124.015-.25.038-.38.038.13 0 .256.023.38.038-.004-.024.004-.052 0-.076zm-9.434 3.641c.197 2.237.882 3.906 1.712 3.906h6.162c.83 0 1.514-1.669 1.712-3.906a3.31 3.31 0 01-.533.038H22.2c-.182 0-.363-.01-.533-.038z"
}));

var SvgLightBulb = function SvgLightBulb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLightBulb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Light Bulb.c7935ca5.svg";
export { ForwardRef as ReactComponent };